<template>
  <div v-if="lang === 'java' || lang === 'kotlin'">
    <i18n-t keypath="examples.addTheFollowingToMethodOfClass" tag="p" scope="global">
      <template #className>
        <code>{{ fileName.replace(/\.(java|kt)/g, '') }}</code>
      </template>
      <template #methodName>
        <code>main</code>
      </template>
    </i18n-t>
  </div>
  <div v-else-if="includeFilenameInMessage">
    <i18n-t keypath="examples.addTheFollowingToFile" tag="p" scope="global">
      <template #fileName>
        <code>{{ fileName }}</code>
      </template>
    </i18n-t>
  </div>
  <div v-else>
    {{ lang }}
    <p>{{ $t('examples.addTheFollowingToYourCode') }}</p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  lang: { type: String, required: true },
  fileName: { type: String, required: true },
});

const includeFilenameInMessage = computed(() =>
  ['curl', 'dotnet', 'javascript', 'php', 'python', 'ruby'].includes(props.lang)
);
</script>
